import { TitleLarge } from 'shared/components/text-elements'
import { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import { Text } from '../../typography'

const Container = styled.div`
    margin: 0 auto 40px;
    text-align: center;

    h1 {
        margin: 0 0 15px;
    }

    ${Text} {
        margin-left: auto;
        margin-right: auto;
    }
`

const ToolTitle = styled.span`
    font-family: 'nexabook', sans-serif;
`

const CreationToolsWelcomeCopy = () => {
    const { tool } = useContext(CreationToolsContext)
    return (
        <Container>
            <TitleLarge as="h1">
                GIPHY <ToolTitle>{CreationTool.title(tool)}</ToolTitle>
            </TitleLarge>
            <Text as="h2">{CreationTool.description(tool)}</Text>
        </Container>
    )
}

export default CreationToolsWelcomeCopy
